import { Language } from '../context/LanguageContext';

interface SnakeTranslations {
    mainTitle: string;
    mainSubtitle: string;
    symbolTitle: string;
    symbolSubtitle: string;
    symbolDescription: string;
    paradiseTitle: string;
    paradiseSubtitle: string;
    paradiseDescription: string;
    moreTitle: string;
    moreSubtitle: string;
    moreDescription: string;
    collectionItems: Array<{
        id: string;
        name: string;
        description: string;
        image: string;
    }>;
}

export const snakeTemplateTranslations: Record<Language, SnakeTranslations> = {
    en: {
        mainTitle: "A SNAKE'S",
        mainSubtitle: "WISDOM",
        symbolTitle: "SNAKE - THE SYMBOL",
        symbolSubtitle: "of occult knowledge",
        symbolDescription: "The snake is appearing in all ancient religions or mythologies at the highest level. In ancient Egypt it appears at the top of the golden masks of the Pharaos and symbolises Divinity. In the Indian Yoga-Disciplines it is Kundalini, the force that rises through the Chakras till the highest, where Unity with the Divine is established. Kukulkan, the feathered snake, headed a pantheon of deities both of the Mayas as also of non-Maya provenances in Middle-America.",
        paradiseTitle: "ANIMAL OF",
        paradiseSubtitle: "PARADISE",
        paradiseDescription: "In Christianity the snake appears in the Genesis of the old Bible. It offers an apple to Adam & Eve, and tells them, that if they eat from the apple, they will be like God. God then was so annoyed about this, that he drove Adam and Eve out of Paradise. The snake is more than just an animal. In all ancient religions and mythologies, the snake is a symbol of Wisdom, Power and Knowledge in the metaphysical worlds.",
        moreTitle: "MORE THAN",
        moreSubtitle: "JUST AN ANIMAL",
        moreDescription: "In all ancient religions and mythologies, the snake is a symbol of Wisdom, Power and Knowledge in the metaphysical worlds.",
        collectionItems: [
            {
                id: "1",
                name: "Snake Ring",
                description: "Pear shape center sapphire, Niveau Elevé cut diamond pavé, 18k yellow gold",
                image: "/images/jewellery_snake_grid_1_ring1.png"
            },
            {
                id: "2",
                name: "Snake Ring",
                description: "Pear shape center sapphire, Niveau Elevé cut diamond pavé, 18k yellow gold",
                image: "/images/jewellery_snake_grid_2_ring2.png"
            },
            {
                id: "3",
                name: "Snake Ring",
                description: "Pear shape center sapphire, Niveau Elevé cut diamond pavé, 18k yellow gold",
                image: "/images/jewellery_snake_grid_3_ring3.png"
            },
            {
                id: "4",
                name: "Snake Ring",
                description: "Pear shape center sapphire, Niveau Elevé cut diamond pavé, 18k white gold",
                image: "/images/jewellery_snake_grid_4_ring4.png"
            },
            {
                id: "5",
                name: "Snake necklace small",
                description: "Pear shape center diamond, Niveau Elevé cut diamond pavé, 18k yellow gold, medium chain",
                image: "/images/jewellery_snake_grid_5_necklace1.png"
            },
            {
                id: "6",
                name: "Snake necklace large",
                description: "Pear shape center diamond, Niveau Elevé cut diamond pavé, 18k yellow gold, large chain",
                image: "/images/jewellery_snake_grid_6_necklace2.png"
            }
        ]
    },
    de: {
        mainTitle: "DIE WEISHEIT",
        mainSubtitle: "EINER SCHLANGE",
        symbolTitle: "SCHLANGE - DAS SYMBOL",
        symbolSubtitle: "DES OKKULTEN WISSENS",
        symbolDescription: "Die Schlange taucht in allen alten Religionen oder Mythologien auf höchster Ebene auf. Im alten Ägypten erscheint sie an der Spitze der goldenen Masken der Pharaonen und symbolisiert die Göttlichkeit. In den indischen Yoga-Disziplinen ist sie Kundalini, die Kraft, die durch die Chakras bis zum höchsten aufsteigt, wo die Einheit mit dem Göttlichen hergestellt wird. Kukulkan, die gefiederte Schlange, stand an der Spitze eines Pantheons von Gottheiten sowohl der Mayas als auch von Nicht-Maya-Volksstämmen in Mittel-Amerika.",
        paradiseTitle: "Die Verführung",
        paradiseSubtitle: "im Paradies",
        paradiseDescription: "Im Christentum taucht die Schlange in der Genesis des Alten Testaments auf. Sie bietet Adam und Eva einen Apfel an und sagt ihnen, dass sie, wenn sie von dem Apfel essen, wie Gott sein werden. Gott war darüber so verärgert, dass er Adam und Eva aus dem Paradies vertrieb. Die Schlange ist mehr als nur ein gewöhnliches Tier. Sie ist ein Symbol für den Türöffner zu den höheren Bewusstseinsebenen.",
        moreTitle: "MEHR ALS",
        moreSubtitle: "NUR EIN TIER",
        moreDescription: "In allen alten Religionen und Mythologien ist die Schlange ein Symbol für Weisheit, Macht und Wissen in den metaphysischen Welten.",
        collectionItems: [
            {
                id: "1",
                name: "Schlangen Ring",
                description: "Tropfenförmiger Spezialschliff-Saphir, Diamanten in Pavé-Fassung 18 Karat Gelbgold",
                image: "/images/jewellery_snake_grid_1_ring1.png"
            },
            {
                id: "2",
                name: "Schlangenring",
                description: "Tropfenförmiger Spezialschliff-Saphir, Diamanten in Pavé-Fassung 18 Karat Gelbgold",
                image: "/images/jewellery_snake_grid_2_ring2.png"
            },
            {
                id: "3",
                name: "Schlangenring",
                description: "Tropfenförmiger Spezialschliff-Saphir, Diamanten in Pavé-Fassung 18 Karat Gelbgold",
                image: "/images/jewellery_snake_grid_3_ring3.png"
            },
            {
                id: "4",
                name: "Schlangenring",
                description: "Tropfenförmiger Spezialschliff-Saphir, Diamanten in Pavé-Fassung 18 Karat Weißgold",
                image: "/images/jewellery_snake_grid_4_ring4.png"
            },
            {
                id: "5",
                name: "Schlangenhalskette klein",
                description: "Diamant in Tropfenform, Brillanten in Pavé-Fassung, 18 Karat Gelbgold, mittelgroße Kette",
                image: "/images/jewellery_snake_grid_5_necklace1.png"
            },
            {
                id: "6",
                name: "Schlangenhalskette groß",
                description: "Diamant in Tropfenform, Brillanten in Pavé-Fassung 18 Karat Gelbgold, große Kette",
                image: "/images/jewellery_snake_grid_6_necklace2.png"
            }
        ]
    }
}; 